module.exports = __webpack_public_path__ + "static/media/cc6.41ba0472.jpg";